import { NavLink } from 'react-router-dom'

const Sidebar = () => {
  const navigationItems = [
    { path: '/dashboard', icon: '📊', label: 'Dashboard' },
    { path: '/products', icon: '📦', label: 'Products' },
    { path: '/categories', icon: '🏷️', label: 'Categories' },
    { path: '/orders', icon: '🛍️', label: 'Orders' },
    { path: '/users', icon: '👥', label: 'Users' },
    { path: '/analytics', icon: '📈', label: 'Analytics' },
    { path: '/settings', icon: '⚙️', label: 'Settings' }
  ]

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="sidebar-logo-icon">🌿</div>
        <div className="sidebar-logo-text">
          <h1>SSP Biotech</h1>
          <span>Admin Panel</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        {navigationItems.map((item) => (
          <div key={item.path} className="nav-item">
            <NavLink
              to={item.path}
              className={({ isActive }) => 
                `nav-link ${isActive ? 'active' : ''}`
              }
            >
              <span className="nav-link-icon">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          </div>
        ))}
      </nav>

      <div style={{ 
        marginTop: 'auto', 
        padding: '2rem', 
        textAlign: 'center',
        color: 'var(--text-tertiary)',
        fontSize: '0.8rem',
        borderTop: '1px solid var(--border-color)'
      }}>
        <p>SSP Biotech Admin v1.0</p>
        <p>admin.sspbiotech.in</p>
      </div>
    </aside>
  )
}

export default Sidebar
